export default "__VITE_ASSET__Bh0$i_x2__"